import { SiteStore } from '@wix/wixstores-client-storefront-sdk';
import { TrackEventName } from '@wix/wixstores-client-core';
import { Cart } from './current-cart-service/types';

export class AnalyticsService {
  private readonly siteStore: SiteStore;
  constructor({ siteStore }: { siteStore: SiteStore }) {
    this.siteStore = siteStore;
  }

  public trackRemoveLineItem({
    lineItemId,
    updatedCart,
    previousCart,
  }: {
    lineItemId: string;
    updatedCart: Cart;
    previousCart: Cart;
  }) {
    const lineItem = previousCart.lineItems?.find(
      ({ _id }) => _id === lineItemId,
    );
    this.siteStore.trackEvent(TrackEventName.REMOVE_FROM_CART, {
      id: lineItem?.source?.catalogReference?.catalogItemId,
      catalogReference: lineItem?.source?.catalogReference,
      name: lineItem?.name?.original,
      price: lineItem?.pricing?.unitPrice?.amount,
      quantity: lineItem?.quantityInfo?.confirmedQuantity,
      sku: lineItem?.attributes?.physicalProperties?.sku,
      currency: updatedCart.businessInfo?.currencyCode,
    });
  }
}
